import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bdb7d18e&scoped=true&lang=pug&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&module=true&lang=css&"
import style1 from "./Index.vue?vue&type=style&index=1&id=bdb7d18e&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bdb7d18e",
  null
  
)

export default component.exports